const jQ = jQuery.noConflict();

class setupSlickSlider{

	constructor(){
		this.sliderWrapper = ".slider-wrapper";
		this.arrowLeft = ".arrow--left";
		this.arrowRight = ".arrow--right";
	}
	setupSlick(){
		if(jQ(this.sliderWrapper).length){
			jQ(this.sliderWrapper).slick({
				slidesToShow: 1,
		       	slidesToScroll: 1,
		      	arrows: true,
		      	prevArrow: this.arrowLeft,
		        nextArrow: this.arrowRight,
		        fade: true,
  				infinite: true,
  				autoplay: true,
  				autoplaySpeed: 4000,
	        	responsive: [
				{
					breakpoint: 991,
					settings: {
						arrows: false,
						centerMode: false,
						fade: false,
						autoplay: false,
					}
				}]
			});
		}
	}


	init(){
		this.setupSlick();
	}
}

const setupSlider = new setupSlickSlider();

export default setupSlider;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/setupslider.js